import { render, staticRenderFns } from "./Authorise.vue?vue&type=template&id=1a887e12&scoped=true&"
import script from "./Authorise.vue?vue&type=script&lang=js&"
export * from "./Authorise.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/authorise.scss?vue&type=style&index=0&id=1a887e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a887e12",
  null
  
)

export default component.exports